import type { ResultWithCorrelationId } from '~/api/middleware/types';
import { httpWithAuth } from '~/clients';
import { getCreditStatus } from '~/constants/endpoints';
import type { FinancingAdapterUserCreditStatusSummary } from '~/contracts/common';

export default function fetchCreditStatus(
  eventCorrelationId: string,
  apiClientId: string,
  controller: AbortController
) {
  return httpWithAuth.get<
    ResultWithCorrelationId<FinancingAdapterUserCreditStatusSummary>
  >(getCreditStatus({ currentPageUrl: window.location.href }), {
    headers: {
      'x-client-id': apiClientId,
      'x-correlation-id': eventCorrelationId
    },
    signal: controller.signal
  });
}
